
export const initialState = {
  data: {
    biologicalSex: '',
    birthDate: '',
    cep: '',
    city: '',
    email: '',
    name: '',
    neighborhood: '',
    phone: '',
    state: '',
    street: '',
    streetNumber: '',
    addressComplement: '',
  },
  cpf: '',
};

const mutations = {
  SET_CLEAR_REGISTRATIONDATA(state) {
    Object.assign(state, initialState);
  },
  SET_REGISTRATION_DATA(state, payload) {
    state.data = {
      addressComplement: payload.addressComplement,
      biologicalSex: payload.biologicalSex,
      birthDate: payload.birthDate,
      cep: payload.cep,
      city: payload.city,
      email: payload.email,
      name: payload.name,
      neighborhood: payload.neighborhood,
      phone: payload.phone,
      state: payload.state,
      street: payload.street,
      streetNumber: payload.streetNumber,
      cpf: payload.cpf,
    };
  },
  SET_CPF(state, payload) {
    state.cpf = payload;
  }
};

export default mutations;
